import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { GenerateBillingRequest, GenerateBillingResponse } from '../models/mxp-billing.model';

@Injectable({ providedIn: 'root' })
export class MxpBillingService {
  private readonly url = environment.paymentUrl.replace(/\/$/, '') + '/api/mxp-billings/generate';

  constructor(private readonly http: HttpClient) {}

  generateBilling(request: GenerateBillingRequest): Observable<GenerateBillingResponse> {
    return this.http.post<GenerateBillingResponse>(this.url, request);
  }
}
